import { App, Button, Popconfirm } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useAppContext } from 'business/contextProviders/useAppContext';
import { useRingValidationV1ControllerValidate } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';
import { queryClient } from 'technical/react-query/client';

export const ValidateRingButton = ({ ringNumber }: { ringNumber: number }) => {
  const { t } = useTranslation();
  const { currentConstructionSiteId, user } = useAppContext();
  const { message } = App.useApp();
  const { mutateAsync: validateRing, isPending } =
    useRingValidationV1ControllerValidate();

  const headers = useRestApiHeaders(Module_Enum.QualityControl);

  const handleValidate = async () => {
    if (!user || !currentConstructionSiteId) {
      return;
    }
    try {
      await validateRing({
        body: {
          authorId: user.id,
          fromRingNumber: ringNumber,
          toRingNumber: ringNumber,
        },
        pathParams: { constructionSiteId: currentConstructionSiteId },
        headers,
      });
      message.open({
        type: 'success',
        content: t(
          'qualityControl.ringComplianceReport.detail.validateButton.success',
        ),
      });
      await queryClient.invalidateQueries({
        queryKey: [
          'v1',
          'quality',
          currentConstructionSiteId,
          'rings-validation',
        ],
      });
    } catch {
      message.open({
        type: 'error',
        content: t(
          'qualityControl.ringComplianceReport.detail.validateButton.error',
        ),
      });
    }
  };

  return (
    <Popconfirm
      title={t(
        'qualityControl.ringComplianceReport.detail.validateButton.confirmTitle',
      )}
      description={t(
        'qualityControl.ringComplianceReport.detail.validateButton.confirmDescription',
      )}
      okText={t(
        'qualityControl.ringComplianceReport.detail.validateButton.confirmOk',
      )}
      cancelText={t(
        'qualityControl.ringComplianceReport.detail.validateButton.confirmCancel',
      )}
      onConfirm={handleValidate}
    >
      <Button type="primary" loading={isPending}>
        {t('qualityControl.ringComplianceReport.detail.validateButton.label')}
      </Button>
    </Popconfirm>
  );
};
